import axios from "axios";
import { getToken } from "../../Utils/UpdateUsersState";

const createCompany = async (formData) => {
  try {
    const res = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}admin_panel/company/`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${getToken()}`,
        },
      },
    );
    return res;
  } catch (e) {
    console.error("Error creating company:", e);
    throw e;
  }
};
const getCompanyData = async () => {
  try {
    const token = getToken();

    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}admin_panel/company/`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );

    return response;
  } catch (error) {
    console.error("Company data fetch error:", error);
    throw error;
  }
};

const getCompanybyId = async (id) => {
  try {
    const token = getToken();

    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}admin_panel/company/?company_id=${id}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );

    return response;
  } catch (error) {
    console.error("Company data fetch error:", error);
    throw error;
  }
};

const deleteCompany = async (company_id) => {
  try {
    const res = await axios.delete(
      `${process.env.REACT_APP_BACKEND_URL}admin_panel/company/`,
      {
        data: { company_id },
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      },
    );

    return res;
  } catch (e) {
    throw e;
  }
};

const editCompany = async (
  company_id,
  companyName,
  companyAddress,
  registrationNumber,
  coverageArea,
  primaryContactPerson,
  primaryContactNumber,
  secondaryContactNumber,
  emailAddress,
  serviceLevelAgreement,
  isDefault,
  status,
  logo,
  override_default,
) => {
  try {
    const formData = new FormData();

    formData.append("company_id", company_id);
    formData.append("company_name", companyName);
    formData.append("company_address", companyAddress);
    formData.append("registration_number", registrationNumber);
    formData.append("coverage_area", coverageArea);
    formData.append("primary_contact_person", primaryContactPerson);
    formData.append("primary_contact_number", primaryContactNumber);
    formData.append("secondary_contact_number", secondaryContactNumber);
    formData.append("email_address", emailAddress);
    formData.append("service_level_agreement_details", serviceLevelAgreement);
    formData.append("is_default", isDefault ? 1 : 0);
    formData.append("override_default", override_default ? 1 : 0);
    formData.append("status", status);

    if (logo) {
      formData.append("logo", logo);
    }

    const res = await axios.patch(
      `${process.env.REACT_APP_BACKEND_URL}admin_panel/company/`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
          "Content-Type": "multipart/form-data",
        },
      },
    );

    return res;
  } catch (e) {
    console.log(e, "error");
    throw e;
  }
};

export {
  createCompany,
  getCompanyData,
  deleteCompany,
  getCompanybyId,
  editCompany,
};
